import { ActionCardData, getFlowStatus } from '.'

function setFlowStatus(ac: ActionCardData) {
  const { flow } = getFlowStatus(ac)

  ac.actionCardFlow = flow
}

export default setFlowStatus
